// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"651":"aece3836","656":"aedd5f18","764":"dc4fd8a2"}[chunkId] + ".css";
};